import { useLocation, useNavigate } from 'react-router-dom';
import { Rail, type RailFooterItem } from '@zarya/ui';
import type { Counters } from '@app/navigation';
import { railGroups, ROUTE_DOCS } from '@app/navigation';
import { useCurrentUser } from '@app/auth/useCurrentUser';
import { t } from '@app/i18n';

export interface ShellRailProps {
  /** Contadores de `getShell` (FR-012). */
  contadores?: Counters | undefined;
}

/**
 * Menu lateral do console (T2, FR-012): grupos Operação · Descoberta · Controle ·
 * Configurações, itens omitidos por papel e contadores atualizados a cada navegação.
 */
export function ShellRail({ contadores }: ShellRailProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { papel } = useCurrentUser();

  // Montado no RENDER, nunca em const de módulo: `t()` avaliado no import congelaria
  // o rótulo no idioma da primeira renderização (a razão de `navLabel` existir, e o
  // que o `frozenLocaleConsts.test.ts` cobra).
  const footerItems: RailFooterItem[] = [
    { href: ROUTE_DOCS, label: t('shell.nav.documentation'), icon: 'file-search' },
  ];

  return (
    <Rail
      groups={railGroups({ papel, contadores })}
      activeHref={location.pathname}
      // A marca NÃO vai para o catálogo: nome de produto não se traduz, e pô-lo
      // lá convidaria alguém a «traduzi-lo» num idioma futuro.
      brand={{ name: '360 Agentic Identity', subtitle: 'PoC' }}
      // Documentação do produto no rodapé (16/09). Entra por aqui, e não por
      // `ROTAS`/`railGroups`, porque `/docs` **não é tela do console**: fora de
      // `ROTAS` ela fica fora do mapa de títulos e da busca — e a busca global é do
      // servidor (identidades, recursos e regras), que não conhece rota nenhuma.
      footer={footerItems}
      onNavigate={(href, e) => {
        // Navegação sem recarregar a página; o `href` real fica no DOM para o
        // usuário poder abrir em outra aba.
        e.preventDefault();
        navigate(href);
      }}
    />
  );
}
